var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutline87X86 = function SvgOutline87X86(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 115 115"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87.173,
    height: 86.387,
    x: 58.909,
    y: -3.88,
    stroke: "#E5E5E5",
    rx: 14.5,
    transform: "rotate(46.625 58.909 -3.88)"
  })));
};
export default SvgOutline87X86;